import { render, staticRenderFns } from "./UiTag.vue?vue&type=template&id=2f523348"
import script from "./UiTag.vue?vue&type=script&lang=js"
export * from "./UiTag.vue?vue&type=script&lang=js"
import style0 from "./UiTag.vue?vue&type=style&index=0&id=2f523348&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports